import { memo } from 'react';

import { LineweightMediumIcon, MessageCirclePlusIcon, MessageSquareIcon, RedoIcon, UndoIcon } from '@air/design-icons';

import { ShortcutsList } from '~/components/ShortcutsList';

export const ANNOTATIONS_SHORTCUTS = [
  {
    id: 'open-comments',
    icon: MessageSquareIcon,
    label: 'Open/close comments panel',
    keys: ['meta+shift+c'],
  },
  {
    id: 'focus-comment-input',
    icon: MessageSquareIcon,
    label: 'Open comments and focus input',
    keys: ['c'],
  },
  {
    id: 'toggle-annotation-mode',
    icon: MessageCirclePlusIcon,
    label: 'Toggle annotation mode',
    keys: ['p'],
  },
  {
    id: 'draw-annotation',
    icon: LineweightMediumIcon,
    label: 'Draw annotation',
    keys: ['meta+shift+d'],
  },
  {
    id: 'undo',
    icon: UndoIcon,
    label: 'Undo',
    keys: ['meta+z'],
  },
  {
    id: 'redo',
    icon: RedoIcon,
    label: 'Redo',
    keys: ['meta+shift+z'],
  },
];

export const AnnotationsShortcutsInfo = memo(() => <ShortcutsList shortcuts={ANNOTATIONS_SHORTCUTS} />);

AnnotationsShortcutsInfo.displayName = 'AnnotationsShortcutsInfo';
